export default "__VITE_ASSET__BYpNZUCj__"